import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=566f7c02"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566f7c02')) {
      api.createRecord('566f7c02', component.options)
    } else {
      api.reload('566f7c02', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=566f7c02", function () {
      api.rerender('566f7c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/authentication/Login.vue"
export default component.exports